module.exports = __webpack_public_path__ + "img/logo_en.d3baaac.png";